import { useCircleV4 } from "@/react/hooks/useCircleV4";

// The member-area AppShell is the Circle 4.0 navigation chrome, so it's gated on
// the active v4 UI (`window.V4_UI`).
export const useIsMemberAreaAppShellEnabled = () => useCircleV4().isCircleV4;
